import React from 'react';
import { useSelector } from 'react-redux';
import { NoItemsYet } from 'components';
import { formatIssueType } from 'utils';
import { noIssueYet } from './constants';

const warnings = [{ description: 'Appointment was removed from claim' }];
export const ApptErrorTab = ({}) => {
    const { item } = useSelector((state) => ({
        item: state.appointment.appointmentById,
    }));

    if (!item?.issues?.length && !item?.removedFromClaimFlag) {
        return <NoItemsYet height={noIssueYet?.height} text={noIssueYet.title} subTitle={noIssueYet.subTitle} image={noIssueYet.image} />;
    }

    return (
        <div className="appt-error-tab-wrapper">
            <div className="full-width">
                {!!item?.issues?.length && (
                    <>
                        <p className="pending-issues">Pending Issues: {item?.issues?.length}</p>
                        {item?.issues?.map((i, j) => (
                            <div key={j} className="appt-tab-error-box">
                                <p style={{ fontWeight: 600, marginRight: 4 }}>{formatIssueType(i?.issueType)}: </p>
                                <p>{i?.description}</p>
                            </div>
                        ))}
                    </>
                )}

                {item?.removedFromClaimFlag && (
                    <div style={{ marginTop: 16 }}>
                        <p className="pending-issues">Warning: 1</p>
                        {warnings?.map((i, j) => (
                            <div key={j} className="appt-tab-warning-box">
                                {/*<p style={{ fontWeight: 600, marginRight: 4 }}>{formatIssueType(i?.issueType)}: </p>*/}
                                <p>{i?.description}</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
